import { useRef, useEffect, useState } from 'react';
import PalmerSectionLabel from './PalmerSectionLabel';

const experiences = [
  { company: 'Nova AI Digital LLC', year: '2022 – Present', role: 'Founder & Creative Director', location: 'New York' },
  { company: 'Modular Eight', year: '2020 – 2022', role: 'Senior Developer', location: 'Osaka' },
  { company: 'Haus of Signal', year: '2018 – 2020', role: 'Creative Technologist', location: 'Berlin' },
  { company: 'Studio Orbit', year: '2016 – 2018', role: 'UI/UX Designer', location: 'Dallas' },
  { company: 'Novaform Labs', year: '2014 – 2016', role: 'Junior Designer', location: 'Kyoto' },
];

export default function PalmerExperience() {
  const sectionRef = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setVisible(true); }, { threshold: 0.05 });
    if (sectionRef.current) obs.observe(sectionRef.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="bg-black py-20">
      <PalmerSectionLabel
        left1="© Experience エクスペリエンス"
        left2="(WDX® — 06)"
        right="Digital Craft"
      />

      <div className="px-6">
        {/* Top: "Tenure." massive left + portrait image right */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-12 items-end">
          <div className="lg:col-span-7">
            <h2
              className={`text-white font-semibold transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
              style={{
                fontFamily: "'DM Sans', sans-serif",
                fontSize: 'clamp(72px, 11vw, 160px)',
                letterSpacing: '-0.05em',
                lineHeight: 0.88,
              }}
            >
              Tenure.
            </h2>
          </div>
          <div className="lg:col-span-5 flex items-end justify-start lg:justify-end gap-4">
            <div
              className={`overflow-hidden transition-all duration-1000 delay-200 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
              style={{ width: 140, height: 190 }}
            >
              <img
                src="https://framerusercontent.com/images/O8QHzRBHCQM4fDoxXZEZmECZs.png"
                alt="Experience"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>

        {/* Experience rows */}
        <div>
          {experiences.map((exp, i) => (
            <div
              key={exp.company}
              className={`border-t border-white/10 py-5 grid grid-cols-2 lg:grid-cols-4 gap-4 hover:bg-white/[0.03] transition-all duration-500 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <div>
                <p className="text-white text-sm font-medium" style={{ fontFamily: "'DM Sans', sans-serif" }}>{exp.company}</p>
              </div>
              <div>
                <p className="text-white/35 text-xs" style={{ fontFamily: "'DM Sans', sans-serif" }}>{exp.year}</p>
              </div>
              <div>
                <p className="text-white/55 text-xs" style={{ fontFamily: "'DM Sans', sans-serif" }}>{exp.role}</p>
              </div>
              <div className="text-right">
                <p className="text-white/25 text-xs" style={{ fontFamily: "'DM Sans', sans-serif" }}>{exp.location}</p>
              </div>
            </div>
          ))}
          <div className="border-t border-white/10"></div>
        </div>
      </div>
    </section>
  );
}
